export default "__VITE_ASSET__D21mLyGu__"